/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
/* istanbul ignore file */
import { createLogger } from 'redux-logger';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import thunk from 'redux-thunk';

import { State } from '../redux';
import { rootReducer } from '../reducers';
import { getNodeEnv } from '@utils/env';
import { get, includes } from '@utils/lodash';

declare const module: any;
let store: Store<State>;

const logger = createLogger({
  collapsed: true,
  predicate: () => {
    /* istanbul ignore else */
    if (get(global, 'IS_TEST')) {
      return false;
    }
    const env = getNodeEnv();
    return includes(['dev'], env);
  },
});

export function configureStore(initialState: Partial<State> = {}) {
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(thunk, logger)));

  if (module.hot) {
    module.hot.accept(() => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const nextRootReducer = require('../reducers/index').rootReducer;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

export function getReduxStore() {
  return store;
}
